import contentSettings from '@site/content.settings'

import { hasCookiebotCategoryConsent, hasCookiebotManager } from '~/app/cookiebot'

const COOKIEBOT_CONSENT_EVENTS = ['CookiebotOnConsentReady', 'CookiebotOnAccept', 'CookiebotOnDecline']
const COOKIEBOT_RENEW_SELECTOR = '[data-cookiebot-renew]'
const MARKETING_EMBED_URL_RE = /(?:youtube(?:-nocookie)?\.com|youtu\.be|vimeo\.com)/i
const IFRAME_RE = /<iframe\b[^>]*\bsrc=(["'])([^"']+)\1[^>]*>\s*<\/iframe>/gi
const PLACEHOLDER_TEXTS = {
  cs: 'Video je dostupné pouze po povolení marketingových souborů cookie.',
  de: 'Dieses Video ist erst nach Zustimmung zu Marketing-Cookies verfugbar.',
  en: 'This video is available only after accepting marketing cookies.',
  sk: 'Video je dostupné až po povolení marketingových súborov cookie.',
}
const PLACEHOLDER_CTA_TEXTS = {
  cs: 'Upravit nastavení cookies',
  de: 'Cookie-Einstellungen ändern',
  en: 'Change cookie settings',
  sk: 'Upraviť nastavenia cookies',
}

function escapeHtml(text) {
  return String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

function getNormalizedUrl(url = '') {
  if (url.indexOf('//') === 0) {
    return `https:${url}`
  }

  return url
}

export default {
  data() {
    return {
      hasMarketingConsent: !hasCookiebotManager(contentSettings),
    }
  },
  mounted() {
    if (typeof window === 'undefined') {
      return
    }

    if (this.$el && typeof this.$el.addEventListener === 'function') {
      this.$el.addEventListener('click', this.handleMarketingEmbedPlaceholderClick)
    }

    if (!hasCookiebotManager(contentSettings)) {
      return
    }

    COOKIEBOT_CONSENT_EVENTS.forEach(eventName => {
      window.addEventListener(eventName, this.updateMarketingConsent)
    })

    this.updateMarketingConsent()
  },
  beforeDestroy() {
    if (typeof window === 'undefined') {
      return
    }

    if (this.$el && typeof this.$el.removeEventListener === 'function') {
      this.$el.removeEventListener('click', this.handleMarketingEmbedPlaceholderClick)
    }

    COOKIEBOT_CONSENT_EVENTS.forEach(eventName => {
      window.removeEventListener(eventName, this.updateMarketingConsent)
    })
  },
  methods: {
    updateMarketingConsent() {
      this.hasMarketingConsent = !hasCookiebotManager(contentSettings) || hasCookiebotCategoryConsent('marketing')
    },
    isMarketingEmbedUrl(url = '') {
      return MARKETING_EMBED_URL_RE.test(getNormalizedUrl(url))
    },
    getMarketingEmbedPlaceholderHtml() {
      const locale = (this.$i18n && this.$i18n.locale) || 'en'
      const text = PLACEHOLDER_TEXTS[locale] || PLACEHOLDER_TEXTS.en
      const ctaText = PLACEHOLDER_CTA_TEXTS[locale] || PLACEHOLDER_CTA_TEXTS.en

      return `
        <div class="MarketingEmbedPlaceholder alert alert-secondary text-center my-3" role="status">
          <p class="MarketingEmbedPlaceholder__text mb-2">${escapeHtml(text)}</p>
          <button
            class="btn btn-primary btn-sm"
            data-cookiebot-renew="true"
            type="button">
            ${escapeHtml(ctaText)}
          </button>
        </div>
      `
    },
    handleMarketingEmbedPlaceholderClick(event) {
      const targetElement =
        event.target && event.target.nodeType === 1 ? event.target : event.target && event.target.parentElement
      const target =
        targetElement && typeof targetElement.closest === 'function' && targetElement.closest(COOKIEBOT_RENEW_SELECTOR)

      if (!target || (this.$el && !this.$el.contains(target))) {
        return
      }

      event.preventDefault()
      this.openCookiebotSettings()
    },
    openCookiebotSettings() {
      if (typeof window === 'undefined' || !window.Cookiebot) {
        return
      }

      if (typeof window.Cookiebot.renew === 'function') {
        window.Cookiebot.renew()
        return
      }

      if (typeof window.Cookiebot.show === 'function') {
        window.Cookiebot.show()
      }
    },
    getConsentAwareEmbedHtml(html) {
      if (!html || this.hasMarketingConsent) {
        return html
      }

      return html.replace(IFRAME_RE, (match, quote, src) => {
        if (!this.isMarketingEmbedUrl(src)) {
          return match
        }

        return this.getMarketingEmbedPlaceholderHtml()
      })
    },
  },
}
